import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { editorProjectServices } from "../../../APIServices/Editor/editorProjectServices";
import { useParams } from "react-router";

const AddNewDataLibrary = ({ Show, Hide, Title, projectData, getEditorProjectData }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [name, setName] = useState("");
  const [fileType, setFileType] = useState("server");
  const [path, setPath] = useState("");
  const { studyId } = useParams()

  const addNewDataLibrary = async () => {
    setButtonLoader(true)
    let userData = {};
    userData.projectId = projectData?.projectId;
    userData.parentId = projectData?.uniqueId;
    userData.name = name;
    userData.fileType = fileType;
    userData.path = path;
    userData.studyId = studyId;
    let data = await editorProjectServices.addNewDataLibrary(
      userData
    );
    setButtonLoader(false)
    if (data?.statusCode === 200) {
      getEditorProjectData();
      setName("")
      // setFileType("")
      setPath("")
      Hide()
    }
  };

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Folder Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              rows={3}
              onChange={(e) => setName(e.target.value)}
              value={name}
              className="fontSize12"
              placeholder="Enter Folder Name"
            />
          </Form.Group>
          {/* <Form.Group className="mb-1">
            <Form.Label className="fw-bold">
              File Type{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => setFileType(e.target.value)}
              value={fileType}
            >
              <option value="">Select File Type</option>
              <option value="system">System</option>
              <option value="server">Server</option>
            </Form.Select>
          </Form.Group> */}
          {fileType === "system" &&
            <Form.Group className="mb-1">
              <Form.Label className="mb-1 fw-bold">
                Path{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                type="text"
                rows={3}
                onChange={(e) => setPath(e.target.value)}
                value={path}
                className="fontSize12"
                placeholder="Enter Path"
              />
            </Form.Group>
          }
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            onClick={addNewDataLibrary}
            disabled={buttonLoader || !name}
            title={Title}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Loading...
              </div>
            ) : (
              Title
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default AddNewDataLibrary;
